
                import "css-modules://src_components_text"
                export default {"Main":"_9d6b51","Inner":"_f5b814","Grey":"_2524fd","DarkGrey":"_000df7","Sidebar":"_0078de","Content":"_e750aa","Copy":"_49bfe4","Anchors":"_025023","Anchor":"_6f2593","NoTopBorder":"_e6b48e","Left":"_cd53ce"}
            